import { render, staticRenderFns } from "./reports-table.vue?vue&type=template&id=7236e80c&lang=pug&"
import script from "./reports-table.vue?vue&type=script&lang=js&"
export * from "./reports-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports